export default "__VITE_ASSET__BXddqmTS__"